class Reel {
    #_offset = 0
    #currentItem = 0
    #items
    #running = false
    #reel

    get #offset() {
        return this.#_offset
    }

    set #offset(value) {
        this.#_offset += value
        this.#reel.style.setProperty("--offset", this.#offset)
    }

    #handleMove(step) {
        const next = this.#getNextElement(step)

        const { left: parentLeft } = this.#reel.getBoundingClientRect()
        const { left: nextLeft } = next.getBoundingClientRect()
        const paddingInlineStart = parseFloat(getComputedStyle(this.#reel).paddingInlineStart)

        this.#offset = nextLeft - parentLeft - paddingInlineStart
    }

    #getNextElement(step) {
        this.#updateCurrentItem(this.#items.item(this.#currentItem))

        let idx = this.#currentItem + step
        if (!this.#items.item(idx)) {
            const length = this.#items.length - 1
            idx = idx > length ? length : 0
        }
        this.#currentItem = idx

        const nextItem = this.#items.item(idx)
        this.#updateNextItem(nextItem)

        return nextItem
    }

    /** @param {HTMLDivElement} item */
    #updateCurrentItem(item) {
        item.classList.remove("visible")
        item.removeAttribute("aria-current")
        this.#setTabindex(item)
    }

    /** @param {HTMLDivElement} item */
    #updateNextItem(item) {
        item.classList.add("visible")
        item.setAttribute("aria-current", true)
        this.#setTabindex(item, true)
    }

    #setTabindex(item, remove = false) {
        const link = item.querySelector("a")

        if (!link) return

        if (remove) link.removeAttribute("tabindex")
        else link.setAttribute("tabindex", "-1")
    }

    #addButtons() {
        const nav = document.createElement("nav")
        const [prev, next] = [this.#button(`<`, -1), this.#button(`>`)]

        nav.classList.add("static")
        nav.replaceChildren(prev, next)

        this.#reel.insertAdjacentElement("afterbegin", nav)
    }

    #button(text, step = 1) {
        const button = document.createElement("button")
        button.addEventListener("click", () => this.#moveItem(step), { passive: true })
        button.replaceChildren(text)

        return button
    }

    #moveItem(step = 1) {
        if (this.#running) return
        else this.#running = true

        this.#handleMove(step)

        // Wait for the transform animation to finish befor we allow the next move.
        setTimeout(() => { this.#running = false }, 150)
    }

    /** 
     * @param {HTMLDivElement} parent 
     */
    constructor(parent) {
        this.#reel = parent
        this.#items = parent.querySelectorAll(".card")
        this.#addButtons()

        window.addEventListener("resize", () => {
            this.#moveItem(0)
        })
    }
}

document.querySelectorAll("[id$=Reel]")
    .forEach(reel => new Reel(reel))